export var VIEWED_AGE_CONFIRMATION = 'Viewed Age Confirmation';
export var SUBMITTED_AGE_CONFIRMATION = 'Submitted Age Confirmation';
export var VIEWED_AGE_CONFIRMATION_ERROR = 'Viewed Age Confirmation Error';
export var UPDATED_USER_AGE = 'Updated User Age';
export var TAPPED_DECLINE_AGE_CONFIRMATION = 'Tapped Decline Age Confirmation';
export var VIEWED_DECLINE_AGE_CONFIRMATION = 'Viewed Decline Age Confirmation Modal';
export var DECLINED_AGE_CONFIRMATION = 'Declined Age Confirmation';